
import { defineComponent, PropType } from 'vue';

interface Discount {
  value: number;
  type: 'CONST' | 'RATE' | 'PRICE';
  options?: {
    onlyYen?: boolean;
  };
}

export default defineComponent({
  name: 'CouponPrice',
  props: {
    discount: {
      type: Object as PropType<Discount>,
      required: true,
    },
  },
});
